export enum PartnerNameEnum {
  LENDING = 'lending',
  GCASH_LENDING = 'gcash_lending',
  GCASH_MERCHANTS = 'gcash_merchants',
}
